import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ValueBox from  '../common/widget/valueBox'
import Row from  '../common/layout/row'
import InfoBox from  '../common/infoBox/infoBox'
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Button from '../common/button/button';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ReactExport from 'react-export-excel-fixed-xlsx';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import imagemCapa from '../assets/images/foto_dashboard.jpg';
import Select from 'react-select';

import { 
	getListaAgrupadoPorSituacao, getListaAgrupadoPorStatus, getListaPorVencimento
} from './dashboardActions';

import contentCardBody from '../common/template/contentCardBody';

class Dashboard extends Component {

	state = {

	}

	constructor(props) {
		super(props);
    }

    componentDidMount() {
		this.props.getListaAgrupadoPorSituacao();
		this.props.getListaAgrupadoPorStatus();
		this.props.getListaPorVencimento();
    }

	// listaAgrupadoPorSituacao: state.dashboard.listaAgrupadoPorSituacao,
	// listaAgrupadoPorStatus: state.dashboard.listaAgrupadoPorStatus,
	// listaPorVencimento: state.dashboard.listaPorVencimento

    render() {

		/*
		Indicadores que acho interessante para portal de compras:

		- Quantos pedidos estão pendentes por situação (em aberto, backorder etc);
		- Quantos pedidos estão atrasados (precisando de atenção);
		- Quantos pedidos vencem esta semana / este mes;
		- Quantos pedidos estão parados por status (solicitado, faturado, em transporte etc);
		*/

        return (
			<section className='content'
				style={{
					
				}}>
				
				<br/>
				<Row alignCenter style={{ backgroundColor: '#00308A', color:'#ffffff', paddingTop: 8 }}>
					<h5>Situações</h5>
				</Row>
				<br/>
				<Row>
					{this.props.listaAgrupadoPorSituacao.map(item => {
						return this.montarCard(item.nome, item.quantidade, '', 4, '#ffffff', '#4977cc')
					})}
				</Row>
				
				<Row alignCenter style={{ backgroundColor: '#00308A', color:'#ffffff', paddingTop: 8 }}>
					<h5>Status</h5>
				</Row>
				<br/>
				<Row>
					{this.props.listaAgrupadoPorStatus.map(item => {
						return this.montarCard(item.nome, item.quantidade, '', 3, '#ffffff', '#788f6a')
					})}
				</Row>

				<Row alignCenter style={{ backgroundColor: '#00308A', color:'#ffffff', paddingTop: 8 }}>
					<h5>Vencimentos</h5>
				</Row>
				<br/>
				<Row>
					{this.props.listaPorVencimento.map(item => {
						return this.montarCard(item.nome, item.quantidade, '', 3, '#ffffff', '#b88430')
					})}
				</Row>
				
			</section>
        )
	}

	montarCard(nome, quantidade, icone, colMin, cor, backgroundColor) {

		return (
			<div class={`col-12 col-sm-6 col-md-${colMin || 3}`} style={{ opacity: 0.8 }}>
				<div class="info-box" style={{ backgroundColor: backgroundColor }}>
					<div class="info-box-content" style={{ textAlign: 'center', color: cor, paddingTop: 16, paddingBottom: 16 }}>
						<span class="info-box-text" style={{ fontWeight: 'bold' }}>{nome}</span>
						<span class="info-box-number" style={{ fontSize: 28, fontWeight: 'bold', marginTop: 26 }}>{quantidade}</span>
					</div>
				</div>
			</div>
		);
	}

	setDialogItens(itens) {
		this.setState({
			...this.state,
			itens: itens
		})
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	aguardando: state.dashboard.aguardando,
	listaAgrupadoPorSituacao: state.dashboard.listaAgrupadoPorSituacao,
	listaAgrupadoPorStatus: state.dashboard.listaAgrupadoPorStatus,
	listaPorVencimento: state.dashboard.listaPorVencimento
});
const mapDispatchToProps = dispatch => bindActionCreators({
	getListaAgrupadoPorSituacao, getListaAgrupadoPorStatus, getListaPorVencimento
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
